import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card, Avatar, CardHeader, CardContent, Box, Link, Typography, Icon, Tooltip, Grid } from '@material-ui/core';
import { FarmContactViewModel, FarmSettingsContactType } from '../models/user';
import { useTranslation } from 'react-i18next';

interface FarmContactCardProps {
  contact: FarmContactViewModel;
  action: React.ReactElement;
}

const useStyles = makeStyles(() =>
  createStyles({
    headerText: {
      display: 'flex',
      alignItems: 'center'
    },
    cardContent: {
      paddingTop: 0
    }
  })
);

const FarmContactCard = ({ contact, action }: FarmContactCardProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const preventDefault = (event: React.SyntheticEvent) => event.preventDefault();

  const renderContactName = (contact: FarmContactViewModel) => {
    return contact.isPrimary ? (
      <div className={classes.headerText}>
        <Tooltip arrow title={t('f-settings-doct-prim')} placement="top">
          <Icon color="primary" fontSize="small">
            {'star'}
          </Icon>
        </Tooltip>
        <Typography variant="body2">{contact.name}</Typography>
      </div>
    ) : (
      contact.name
    );
  };

  return (
    <Box width={1}>
      <Card elevation={1}>
        <CardHeader
          avatar={<Avatar color="primary">{contact.name[0]}</Avatar>}
          action={action}
          title={renderContactName(contact)}
          subheader={
            contact.phone && (
              <Link href={`tel:${contact.phone}`} onClick={preventDefault}>
                {contact.phone}
              </Link>
            )
          }
        />
        <CardContent className={classes.cardContent}>
          <Grid container>
            <Grid item md={6}>
              <Typography variant="subtitle2">{t('f-com-email')}</Typography>
              <Link href={`mailto:${contact.email}`} onClick={preventDefault} variant="body1">
                {contact.email}
              </Link>
            </Grid>

            <Grid item md={6}>
              <Typography variant="subtitle2">{t('f-settings-con-type')}</Typography>
              <Typography variant="body1">{FarmSettingsContactType[contact.type]}</Typography>
            </Grid>

            {contact.info && (
              <Grid item md={6}>
                <Typography variant="subtitle2">{t('f-com-info')}</Typography>
                <Typography variant="body1">{contact.info}</Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FarmContactCard;
